import { Box, Icon, Stack } from "@chakra-ui/react";
import { Heading22 } from "components/Heading";
import { MeetingId } from "features/Resources/Meeting/models";
import { Text14 } from "components/Text";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import SelectFromMeetingList from "features/Resources/Meeting/Components/SelectFromMeetingList";
import { SecondaryButton } from "components/Button";
import { LuCalendarPlus } from "react-icons/lu";
import { useMeetingDetailQuery } from "features/Resources/Meeting/hooks";

interface SelectMeetingFormProps {
  meetingId: MeetingId;
  onClickScheduleSession?: () => void;
}

export default function SelectMeetingForm({ meetingId, onClickScheduleSession }: SelectMeetingFormProps) {
  const { data: meeting } = useMeetingDetailQuery(meetingId);
  return (
    <Stack gap="4">
      <Heading22>Select Existing Session</Heading22>
      <Text14>Please select an existing session you want this new hire to join.</Text14>
      <HorizontalGreyBlackField label="Name"><Text14>{meeting?.name}</Text14></HorizontalGreyBlackField>
      <SelectFromMeetingList meetingId={meetingId} />
      {onClickScheduleSession && !meeting?.isRecurring && (
        <Box>
          <SecondaryButton
            h="32px"
            rightIcon={<Icon as={LuCalendarPlus} />}
            onClick={onClickScheduleSession}
          >
            Schedule New Session
          </SecondaryButton>
        </Box>
      )}
    </Stack>
  );
}
